import { Model as t } from "../../../../model.js";
class d extends t {
  constructor(s) {
    super(), this.settings = s.settings, this.design = s.design, this.wallet = s.wallet;
  }
}
export {
  d as LoyaltyProgrammeConfigurationModel
};
//# sourceMappingURL=loyaltyProgrammeConfiguration.model.js.map
